import { MutationOptions, useMutation, useQueryClient } from "react-query"
import { useApiClient } from "../../api-client/api-client.hooks"

interface Args {
  projectId: string
  sectionId: string
  position: number
}

export const useReorderProjectSectionMutation = (options?: MutationOptions<any,any,any>) => {
  const apiClient = useApiClient()

  const mutation = useMutation(
    ["reorder-section"],
    async (params: Args) => {
      const { sectionId, projectId, position } = params

      const response = await apiClient.reorderSection(
        projectId,
        sectionId,
        position
      )

      if (!response.ok) {
        throw response.errors
      }

      return response
    },
    options
  )

  return mutation
}

export default useReorderProjectSectionMutation